import { FC, useCallback, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { useInterval } from 'react-use'
import styles from './index.module.sass'

dayjs.extend(duration)

interface Props {
  endTime?: Date | number;
}

const CountdownTimer: FC<Props> = ({ endTime }) => {
  const [text, updateText] = useState('')
  const update = useCallback(() => {
    const endT = dayjs(endTime)
    if (!endT.isValid()) {
      updateText('--:--:--')
    } else {
      const now = dayjs()
      const diff = dayjs.duration(endT.diff(now))
      if (diff.asSeconds() >= 0) {
        const hours = Math.min(99, Math.floor(diff.asHours()))
        updateText(`${hours}${diff.format(':mm:ss')}`)
      } else {
        updateText('--:--:--')
      }
    }
  }, [endTime])

  useEffect(() => {
    update()
  }, [update])

  useInterval(update, 1000)

  return <div className={styles.cd}>{text}</div>
}

export default CountdownTimer
